import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #d97706',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};
const rowStyle = { display: 'flex', gap: 6, marginBottom: 6 };

export default function OteNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#fbbf24' }}>🎯 Optimal Trade Entry</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select value={data.direction || 'bullish'} onChange={(e) => onChange('direction', e.target.value)} style={selStyle}>
        <option value="bullish">Bullish (up-leg pullback)</option>
        <option value="bearish">Bearish (down-leg pullback)</option>
      </select>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>Low fib</label>
          <input type="number" step="0.01" min={0} max={1} value={data.low_fib ?? 0.62}
            onChange={(e) => onChange('low_fib', parseFloat(e.target.value))} style={{ ...selStyle, marginBottom: 0 }} />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>High fib</label>
          <input type="number" step="0.01" min={0} max={1} value={data.high_fib ?? 0.79}
            onChange={(e) => onChange('high_fib', parseFloat(e.target.value))} style={{ ...selStyle, marginBottom: 0 }} />
        </div>
      </div>

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        Fires (1) when price sits in the retracement band of the last swing leg. Compare with value 1.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#d97706' }} />
    </div>
  );
}
